"use strict";
(function (global) {

  /**
   * Создать задачу с вложениями.
   *
   * @function WebAccess.services.task.createTaskWithAttachments
   * @param {array} attachments Массив объектов вида {{ID: 'ИД', Kind: 'Тип', CompCode: 'Код справочника'}}
   * @return {Deferred} deferred-объект для управления отложенными вызовами.
   * @example
   *
   *  //Создать задачу с вложением.
   *  //В данном приере вложение - это текущий объект.
   *  //После создания задачи откроется ее карточка.
   *  var call = WA.services.task.createTaskWithAttachments([{ 'ID': WA.current.getID(),
   *                                                 'Kind': WA.current.getKind(),
   *                                                  'CompCode': WA.current.getReferenceCode }])
   *  call.success(function (res) {
   *   window.open("Task.aspx?view=Card&mode=edit&id=" + res, "task" + res);
   * });
   */
  global.task.createTaskWithAttachments = function (attachments) {
    return global.callSync("/Task.asmx/CreateTaskWithAttachments", {
      Attachments: attachments
    });
  };

   /**
   * Установить права на вложения задачи.
   *
   * @function WebAccess.services.task.setAttachmentsRights
   * @param {int} taskID ИД задачи
   * @param {int} rights Устанавливаемый тип прав
   * @return {Deferred} deferred-объект для управления отложенными вызовами.
   * @example
   *
   * //Запретит доступ к вложениям текущей задачи.
   * WebAccess.services.task.setAttachmentsRights(WA.CR.getID(), ACCESS_RIGHTS.NO_ACCESS).;
   */
  global.task.setAttachmentsRights = function (taskID, rights) {
    return global.callSync("/Task.asmx/SetAttachmentsRights", {
      TaskID: taskID, Rights: rights
    }, null, null, true);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess.services);
